export default __webpack_public_path__ + "5a2ec274cb40179760a1d1d847552cf1.png";